import franchiseData from '../data/franchiseApiData.json';

export const shortName = (team: string) => {
  // Try to find the franchise in the data
  const franchise = franchiseData.data.find(
    (f) => f.teamName.toLowerCase() === team.toLowerCase()
  );

  if (franchise) {
    return franchise.abbreviation;
  }

  // Fallback to previous logic for special cases and unknown teams
  switch (team) {
    case 'TBD':
      return 'TBD';
    default:
      return team.replace('Team ', '').slice(0, 3).toUpperCase();
  }
};
